<top-navig transparent="true" [displayFam]="true" [transp]="true" [displayLogo]="true" [b_bottom]="true"
    displaySing="true" (openFilterFamEv)="openModalFam(template)"></top-navig>
<div class="home">
    <video onloadedmetadata="this.muted=true" autoplay loop preload="auto" id="myVideo">
        <source src="assets/videos/pasta.webm">
    </video>
    <div class="action">
        <img src="assets/images/logo.png" class="logoHome" alt="logo">
        <a (click)="goToCarte()" class="add-to-cart btn">
            Commander
        </a>
        <div class="gradient-border" id="imgbox" *ngIf="enablePayement">
            <img src="assets/images/payementbanner.jpg" alt="Paiement par carte bancaire">
        </div>
    </div>
    <!-- <div class="slider-description">
        <div class="sou-d">
             <h3>COMMANDEZ EN LIGNE</h3> -->

            <!-- <div class="modes" *ngIf="orderTypes.length>0">
                <button *ngFor="let type of orderTypes;let i=index" (click)="goToModes(type.id)">
                    <p>{{type.label}}</p>

                    <img class="img" [src]="'assets/images/'+type.id+'.png'" width="75px" alt="">
                    <span>
                    </span>
                </button>
            </div>

        </div>
    </div> -->
    <products></products>
    <menus></menus>
    <div style="display: none">
        <table>
            <thead>
                <th>Zone</th>
                <th>Min de commande</th>
            </thead>
            <tbody>
                <tr *ngFor="let zone of authorizedCities">
                    <td>
                        <a href="/commander/livraison-{{pdv.speciality}}-{{ zone.name | lowercase }}-{{
                            zone.postalCode
                          }}" title="livraison {{zone.name}} {{zone.postalCode}}">{{zone.name}}
                            {{zone.postalCode}}</a>
                    </td>
                    <td class="text-center">{{zone.amountMiniDelivery}}€</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<ng-template #template>
    <div class="modal-body">
        <ng-container *ngFor="let family of families;let i=index">
            <label class="container" (click)="selectFam(family)">
                <img class="img img-filter" width="28px;" [src]="family.avatar|absolutePath :'families'"
                    [alt]="family.label">
                {{family.label}}
            </label>
        </ng-container>
    </div>
</ng-template>